const useVerifyS2BBrowser = () => {
    const isSumadi = navigator.userAgent.includes('sumadi-app');
    const isElectron = navigator.userAgent.includes('Electron');
    let onS2bBrowser = false;
    if (isSumadi && isElectron) {
        onS2bBrowser = true;
    }
    return { onS2bBrowser };
};
export default useVerifyS2BBrowser;
